import {componentGroups as defaultComponentGroups} from "../ToDos";
import ButtonWeex from "../elements/ButtonWeex";
import {ElementStyles} from "../elements/ElementStyles";
import SelectWeex from "../elements/SelectWeex";
import {useState, useEffect} from "react";

const styles = {
    container: {
        justifyContent: "space-around",
        flexDirection: "column",
        display: "flex",
        // minHeight: "480px",
        borderRadius: ElementStyles.borderRadius,
        boxSizing: "inherit",
        background: "var(--background)",
        minWidth: "250px",
        zIndex: "10",
        position: "relative"
    },
    saveButton: {
        flexGrow: "1",
        marginRight: "5px",
        background: "red"
    },
    abortButton: {
        flexGrow: "1",
        marginLeft: "5px",
        background: "green"
    }
};

export default function ComponentsMenu({pushRoute, close, tags, setSearch, ...props}){

    const [selection, setSelection] = useState(null);
    const [input, setInput] = useState("");
    const [componentGroups, setComponentGroups] = useState(defaultComponentGroups);

    useEffect(() => {
        const timer = setTimeout(() => {
            console.log(input);
        }, 1000);
        return clearTimeout(timer);
    }, [input]);

    useEffect(() => {
        setComponentGroups([
            ...tags.filter((tag) => tag.favorite === true)?.map(tag => {
                return {
                    value: tag.name,
                    label: tag.name,
                    short: tag.name,
                    color: "#914848",
                    ...tag
                };
            }) ?? [], ...tags?.filter(t=>t.name === "Benchmark"),...defaultComponentGroups]);
    }, [tags]);

    return (<div style={{...styles.container}} {...props}>
        <div style={{marginBottom: 10}}>
            <SelectWeex placeholder={"Suche nach Tag..."} value={selection} options={tags?.filter(tag=>tag.name !== "Benchmark") ?? []}
                        style={{marginBottom: 2}}
                        onChange={(e) => setSelection(e)} onInputChange={setInput} isMulti={true}
                        onEnter={(e) => {
                            if(selection){
                                setSearch(selection);
                                pushRoute("SEARCH");
                            }
                        }}/>
            {/*<ButtonWeex*/}
            {/*    style={{background: "gray"}}*/}
            {/*    arrow={true}*/}
            {/*    onClick={() => {*/}
            {/*        if(selection){*/}
            {/*            setSearch(selection);*/}
            {/*            pushRoute("SEARCH");*/}
            {/*        }*/}
            {/*    }}*/}
            {/*>Suchen...</ButtonWeex>*/}
        </div>
        {componentGroups.map((componentGroup, index) =>
            <div style={{marginTop: index === componentGroups.length - (componentGroups.find(t=>t.name === "Benchmark")?3:2) ? "16px" : "4px"}}
                 key={"menuItem_" + index}>
                <ButtonWeex
                    id={"Button_" + index}
                    style={{background: componentGroup.color?? "var(--darkaccent)"}}
                    onClick={() => {
                        if(componentGroup.short === "SAVED"){
                            setSearch("");
                        }
                        else{
                            setSearch([componentGroup]);
                        }
                        pushRoute(componentGroup.id ?? componentGroup.short);
                    }}
                    key={"Button_" + index}
                    arrow={true}
                >
                    {componentGroup.label}
                </ButtonWeex>
            </div>
        )}
        <ButtonWeex onClick={close}>Schließen</ButtonWeex>
    </div>);
}